import { log } from './';

export default (req) => {
	console.log(req);
	//const { status, statusText } = req;
	//log(__filename, statusText, "error");
	//log(__filename, status, "error");
};
